import { ReminderOption } from "./reminderOptions";

export interface ReviewAndSubmitDetails {
  additionalDetails: string;
  reminderOption: ReminderOption;
  patientAgrees?: boolean;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestReviewAndSubmitDetails: ReviewAndSubmitDetails = {
  additionalDetails: 'Additional details',
  reminderOption: ReminderOption.Text,
  patientAgrees: true,
};
